import { ICONS } from './icons';
import {
  BETTING_TASKS_MODULES,
  HISTORY_MODULES,
  JACKPOT_MODULE_NAMES,
  VOUCHER_FILTER_NAME,
  VOUCHER_MODULE_NAMES
} from './enums';
import { ROUTES } from './routes';
import { TransactionsAPI } from './apiURL';

export const TASK_BAR_MENU_ITEMS = [
  {
    className: 'task-bar-button',
    hasSelection: true,
    buttonName: ROUTES.HOME,
    routerLink: ROUTES.HOME,
    content: 'Početna',
    imgSrc: ICONS.HOME,
    selectedImgSrc: ICONS.HOME_SELECTED
  },
  {
    className: 'task-bar-button',
    hasSelection: true,
    buttonName: ROUTES.MAX_VOUCHERS,
    routerLink: ROUTES.MAX_VOUCHERS,
    content: 'Prodavnica',
    imgSrc: ICONS.MARKETPLACE,
    selectedImgSrc: ICONS.MARKETPLACE_SELECTED
  },
  {
    className: 'task-bar-button scanner__btn',
    hasSelection: true,
    buttonName: ROUTES.QR_SCANNER,
    routerLink: ROUTES.QR_SCANNER,
    content: 'Skeniraj',
    imgSrc: ICONS.SCAN,
    selectedImgSrc: ICONS.SCAN_SELECTED
  },
  {
    className: 'task-bar-button',
    hasSelection: true,
    buttonName: ROUTES.BAR_CODE,
    routerLink: ROUTES.BAR_CODE,
    content: 'Kartica',
    imgSrc: ICONS.CARD,
    selectedImgSrc: ICONS.CARD_SELECTED
  },
  {
    className: 'task-bar-button',
    hasSelection: true,
    buttonName: ROUTES.PROFILE,
    routerLink: ROUTES.PROFILE,
    content: 'Profil',
    imgSrc: ICONS.PROFILE,
    selectedImgSrc: ICONS.PROFILE_SELECTED
  }
];

export const VOUCHER_TAB_MENU_ITEMS = [
  {
    content: 'Svi',
    filterName: VOUCHER_FILTER_NAME.ALL
  },
  {
    content: 'Sport',
    filterName: VOUCHER_FILTER_NAME.SPORT
  },
  {
    content: 'Slot',
    filterName: VOUCHER_FILTER_NAME.SLOT
  },
  {
    content: 'Robni',
    filterName: VOUCHER_FILTER_NAME.PRODUCT
  }
];

export const VOUCHER_MODULE_MENU_ITEMS = [
  {
    content: 'Prodavnica',
    moduleName: VOUCHER_MODULE_NAMES.SHOP_VOUCHERS
  },
  {
    content: 'Moji vaučeri',
    moduleName: VOUCHER_MODULE_NAMES.MY_VOUCHERS
  }
];

export const BETTING_TASKS_TAB_MENU_ITEMS = [
  {
    content: 'U toku',
    moduleName: BETTING_TASKS_MODULES.IN_PROGRESS
  },
  {
    content: 'Završeni',
    moduleName: BETTING_TASKS_MODULES.FINISHED
  }
];

export const JACKPOT_MENU_ITEMS = [
  {
    content: 'Lokalni',
    moduleName: JACKPOT_MODULE_NAMES.LOCAL
  },
  {
    content: 'Globalni',
    moduleName: JACKPOT_MODULE_NAMES.GLOBAL
  }
];

export const HISTORY_TAB_MENU_ITEMS = [
  {
    className: HISTORY_MODULES.MAX_CAFE,
    content: 'MaxCafé',
    apiUrl: TransactionsAPI.GET_ALL_TRANSACTIONS_FOR_CATERING
  },
  {
    className: HISTORY_MODULES.BETTING,
    content: 'Klađenje',
    apiUrl: TransactionsAPI.GET_ALL_TRANSACTIONS_FOR_BETTING
  },
  {
    className: HISTORY_MODULES.MBC_EXPIRED,
    content: 'Istekli MBC',
    apiUrl: TransactionsAPI.GET_TRANSACTIONS_FOR_ALL_EXPIRING_MBC
  }
];
